import { CommonDataDTO } from './../../../requests/model/combos-model';
import { Component, Input, OnInit } from '@angular/core';
import { ReqOpsDetailsDTO } from '@app/control-panel/models/control-panel.model';
import { PanelStore } from '@app/requests/panel/panel.store';
import { MatTableDataSource } from '@angular/material/table';
import {
  CONDICIONADA_PENDIENTE_DE_FORMALIZACION,
  REQUEST_APPROVED,
  REQUEST_DENIED,
  REQUEST_PAID_PENDING_VALIDATION,
  REQUEST_PENDING,
  REQUEST_PENDING_PAYMENT_INCIDENT,
  REQUEST_REGULARISE_PAID_VALIDATED,
  REQUEST_SIGNED,
  REQUEST_STUDYING,
  REQUEST_CONDITIONED_PENDING_FORMALIZATION,
} from '@app/@core/constants/requests.constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-requests-with-detalil-table',
  templateUrl: './requests-with-detalil-table.component.html',
  styleUrls: ['./requests-with-detalil-table.component.scss'],
})
export class RequestsWithDetalilTableComponent implements OnInit {
  @Input() operations: Array<ReqOpsDetailsDTO>;

  state: CommonDataDTO;
  dataSource = new MatTableDataSource<ReqOpsDetailsDTO>();
  public classAttribute: string;

  displayedColumns: string[] = [
    'registerOffice',
    'request',
    'customerName',
    'originAgent',
    'vendor',
    'investment',
    'product',
    'article',
    'calification',
    'brand',
    'entrance',
    'resolution',
    'payDate',
    'division',
    'security',
    'over',
    'tir',
    'investmentComplement',
  ];

  constructor(private panelStore: PanelStore, private translateService: TranslateService) {}

  ngOnInit() {
    this.state = this.panelStore.getStatusById(this.operations[0].situationId);
    this.dataSource.data = this.operations;

    switch (this.state.id) {
      case REQUEST_PENDING:
        this.classAttribute = 'panel-request__card-header-icon--pending';
        break;
      case REQUEST_APPROVED:
        this.classAttribute = 'panel-request__card-header-icon--approved';
        break;
      case REQUEST_STUDYING:
        this.classAttribute = 'panel-request__card-header-icon--study';
        break;
      case REQUEST_DENIED:
        this.classAttribute = 'panel-request__card-header-icon--denied';
        break;
      case REQUEST_PAID_PENDING_VALIDATION:
        this.classAttribute = 'panel-request__card-header-icon--pending';
        break;
      case REQUEST_REGULARISE_PAID_VALIDATED:
        this.classAttribute = 'panel-request__card-header-icon--formalized';
        break;
      case REQUEST_DENIED:
        this.classAttribute = 'panel-request__card-header-icon--canceled';
        break;
      case REQUEST_PENDING_PAYMENT_INCIDENT:
        this.classAttribute = 'panel-request__card-header-icon--pending-incidents';
        break;
      case REQUEST_SIGNED:
        this.classAttribute = 'panel-request__card-header-icon--signed';
        break;
      case REQUEST_CONDITIONED_PENDING_FORMALIZATION:
        this.classAttribute = 'panel-request__card-header-icon--conditioned';
        break;
      default:
        console.error('No se ha encontrado estado de solicitudes');
    }
  }

  totalOperations(): string {
    return this.dataSource.data.length + ' ' + this.translateService.instant(this.state.value);
  }
}
